import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';

import { company } from '~/company/Company';
import { useCategoryAnalytics } from '~/hooks/useCategoryAnalytics';
import { Category } from '~/stores/CategoriesStore';

import CategoryBlockTitle from '../CategoryBlockTitle';
import { cfSrcForImage, createCategoryUrl } from '../utils';

import styles from './CategoriesTilesXSMultirow.module.scss';

interface CategoriesCarouselXSProps {
  category: Category;
  level?: number;
}

const CategoriesTilesXSMultirow = ({
  category,
  level = 2,
}: CategoriesCarouselXSProps) => {
  const { handleClickCategory } = useCategoryAnalytics();

  const subcategories = (() => {
    if (level === 3) {
      const allChildren: Category[] = [];

      category.subcategory?.forEach((subCategory) => {
        allChildren.push(...subCategory.subcategory);
      });

      return allChildren;
    }

    return category.subcategory ?? [];
  })();

  if (!subcategories.length || !subcategories[0]?.id) {
    return null;
  }

  return (
    <div className={styles.container}>
      <CategoryBlockTitle
        text={category.name}
        className={styles.title}
        categoryId={category.id}
      />
      <div className={styles.items}>
        {subcategories.map(
          ({ name, previewImage, id, previewText, tileSize }) => {
            const tileSizeClassName = tileSize
              ? TILES_CLASS_NAMES[tileSize]
              : undefined;

            const backgroundImage = cfSrcForImage(previewImage, {
              width: 180,
              height: 180,
            });

            return (
              <div
                className={classes([
                  styles.item,
                  styles.tile,
                  company.tileSizeEnabled ? tileSizeClassName : styles.tile__x1,
                ])}
                key={`category-${id}`}
              >
                <Link
                  data-link={`category-${id}`}
                  onClick={handleClickCategory(id)}
                  to={createCategoryUrl({ id })}
                  className={styles.link}
                  style={{
                    backgroundImage: `var(--tileMask), url('${backgroundImage}')`,
                  }}
                >
                  <div className={styles.itemTitle}>
                    <span>{previewText || name}</span>
                  </div>
                </Link>
              </div>
            );
          },
        )}
      </div>
    </div>
  );
};

const TILES_CLASS_NAMES: Record<number, string | undefined> = {
  1: styles.tile__x1,
  2: styles.tile__x2,
  3: styles.tile__x3,
};

export default observer(CategoriesTilesXSMultirow);
